import { Warning } from 'assets/icons';
import PanelCard from 'components/card/PanelCard';
import Tooltip from 'components/tooltips/Tooltips';
import { remunerationSections } from 'helper/remunerationConditions';

/**
 * The company's remuneration conditions, read-only: the contract preview
 * (JBWEB-1208) and the invoice detail (JBWEB-1274) each check a document
 * against them, and neither opens an editor. `contentClassName` sizes the
 * text to the screen it sits in: the invoice detail writes its fields small.
 */
const RemunerationConditionsCard = ({ companyInfo, contentClassName = '' }) => {
  const sections = remunerationSections(companyInfo);

  return (
    <PanelCard
      title={'Conditions de rémunération'}
      collapsible
      contentClassName={`divide-y ${contentClassName}`}
    >
      {sections.map((section) => (
        <div
          key={section.key}
          className={'py-3 px-4 flex justify-between gap-2'}
        >
          <div className={'min-w-0'}>
            <div className={'text-gray-900'}>{section.title}</div>
            {section.intro && (
              <div className={'text-gray-500'}>{section.intro}</div>
            )}
            {section.bullets.length > 0 && (
              <ul className={'list-disc list-inside text-gray-500'}>
                {section.bullets.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            )}
            {section.extra && (
              <div className={'text-gray-500'}>{section.extra}</div>
            )}
          </div>
          {/* Same warning the company panel shows, and for the same reason:
              a section still on its defaults was never agreed with this
              client, which is worth knowing while reading their documents. */}
          {section.isDefault && (
            <Tooltip text={'Données par défaut'} placement={'top'} zIndex={60}>
              <span className={'my-auto shrink-0 cursor-help'}>
                <Warning wh={20} color={'#975612'} />
              </span>
            </Tooltip>
          )}
        </div>
      ))}
    </PanelCard>
  );
};

export default RemunerationConditionsCard;
